import {
  FabricObject, ElementName, LoadingType,
} from '@meitu/whee-infinite-canvas';
import { getDefaultName } from '$/utils/canvasUtil';
import { createTaskMark, taskQuery } from '$/api/canvasRquest';
import useCanvasStore from '$/store/useCanvasStore';
import { deleteTask, findTask, hasTaskByLayerId } from '$/store/useLayerTaskStore';
import { message, MessageContent } from '$/components/Message';
import { insertImage } from '$/store/useCanvasObjectStore';
import { useOfficialStore } from '$/store/useOfficialStore';
import { registerCanvasToolImageToAssetLibrary, resolveAssetToolType } from '$/utils/canvasToolAssetRegister';
import { TaskCategory } from '../../../../../api/server.types';
import { saveLayerData } from '../layerData';

export interface EditorTip {
  failTip?: MessageContent;
  successTip?: MessageContent;

}
export interface QueryEditorImageParams {
  layerId: string;
  roomId: string;
  taskId: string;
}

export { getTaskStatusEnum } from '$/utils/taskStatus';

/**
 * 编辑图片 任务轮询
 *
 * @export
 * @param {(QueryEditorImageParams & EditorTip)} {
 *   layerId,
 *   roomId,
 *   taskId,
 *   failTip,
 * }
 * @return {*}
 */
export async function queryEditorImageTaskPolling({
  layerId,
  roomId,
  taskId,
  failTip,
}: QueryEditorImageParams & EditorTip) {
  const { render } = useCanvasStore.getState();
  console.log(333333, 'queryEditorImageTaskPolling', roomId, taskId);
  try {
    const dataList = await taskQuery(roomId!, taskId);
    const data = dataList[0];
    console.log(222222, 'queryEditorImageTaskPolling', data);
    // 成功
    if (getTaskStatusEnum(data.status) === 'success') {
      const task = findTask(data.id);
      if (task) {
        task.callback({
          result_images: data.result_images,
          result: data.result,
          ...task.customData,
          taskId,
          layerId,
          roomId,
        });
      }
      return;
    }
    // 失败
    if (getTaskStatusEnum(data.status) === 'fail') {
      deleteTask(taskId);
      layerId.split(',').forEach((id) => {
        render?.Actions.setLoaded(id);
      });
      // render?.Actions.setLoaded(layerId);
      // 安审拦截走后端msg提示
      if (data.status === 98) {
        message.error(data.fail_msg || failTip, 2);
      } else {
        failTip && message.error(failTip, 2);
      }
      return;
    }
    // 轮询
    if (getTaskStatusEnum(data.status) === 'polling') {
      window.setTimeout(() => {
        queryEditorImageTaskPolling({
          layerId,
          roomId,
          taskId,
          failTip,
        });
      }, 2000);
    }
  } catch (error) {
    render?.Actions.setLoaded(layerId);
    deleteTask(taskId);
  }
}
export interface ResultImagesItem {
  alpha_status: number;
  height: number;
  image_status: number;
  url_short: string;
  url_sign: string;
  url_water_sign: string;
  width: number;
}
export interface CallbackParams extends QueryEditorImageParams {
  result_images: ResultImagesItem[];
  result: string;
  width: number;
  height: number;
  shapeName?: string;
  left: number;
  top: number;
  taskCategory?: TaskCategory;
}

/**
 * 编辑图片成功回调
 *
 * @export
 * @param {(CallbackParams & EditorTip)} {
 *   result_images,
 *   result,
 *   layerId,
 *   roomId,
 *   taskId,
 *   width,
 *   height,
 *   left,
 *   top,
 *   successTip,
 * }
 * @param {boolean} [isFirst=true]
 * @param {boolean} [isWatermarkSeparated=true] 图片是否区分水印展示
 */
export async function editorImageSuccessCallback({
  result_images,
  layerId,
  roomId,
  taskId,
  width,
  height,
  left,
  top,
  successTip,
  taskCategory,
}: CallbackParams & EditorTip, isFirst = true, isWatermarkSeparated = false) {
  const { render } = useCanvasStore.getState();
  const isOversea = useOfficialStore.getState().isOversea();
  const sizeObj = (taskCategory === TaskCategory.EXTEND || taskCategory === TaskCategory.MAGICSR || taskCategory === TaskCategory.FUSION)
    ? {}
    : { width, height };
  const first = result_images[0];
  const signUrl = (first?.url_sign || '').trim();
  const toolType = taskCategory != null ? resolveAssetToolType(String(taskCategory)) : 'canvas_editor';
  let toolAssetId: number | undefined;
  if (signUrl) {
    const thumb = isWatermarkSeparated && !isOversea && (first.url_water_sign || '').trim()
      ? first.url_water_sign.trim()
      : undefined;
    toolAssetId = await registerCanvasToolImageToAssetLibrary({
      url: signUrl,
      toolType,
      taskId,
      ext: 'png',
      width: first.width,
      height: first.height,
      ...(thumb ? { thumbnailUrl: thumb } : {}),
      ...(thumb ? { watermarkUrl: thumb } : {}),
    });
  }
  const newImageObject = await insertImage({
    left: left - width / 2,
    top: top - height / 2,
    ...sizeObj,
    watermarkUrl: isWatermarkSeparated && !isOversea ? first.url_water_sign : '',
    url: first.url_sign,
    uri: first.url_sign,
    name: getDefaultName('image'),
    suffix: 'png',
    insertPos: 'right',
    taskId,
    extraData: {
      role: 'assistant',
      ...(toolAssetId != null ? { asset_id: toolAssetId } : {}),
    },
  });
  // 不是首次的不需要隐藏Loading
  if (isFirst) {
    layerId.split(',').forEach((id) => {
      render?.Actions.setLoaded(id);
    });
  }
  // 任务标记，完成后标记，下次进入就不需要再轮询了
  createTaskMark(roomId, taskId);
  // 保存数据
  successTip && message.success(successTip, 2);
  saveLayerData(null, [newImageObject]);
  deleteTask(taskId);
}

/**
 * 检查图片大小 是否满足要求 10M
 *
 * @export
 * @param {Blob} blob
 * @return {*}
 */
export function checkEditorSize(blob: Blob) {
  if (blob.size > 1024 * 1024 * 10) {
    message.error('RoboNeo_Web_image_editor_max');
    return false;
  }
  return true;
}

/**
 * 任务失败回调
 *
 * @export
 * @param {string} taskId
 * @param {string} layerId
 */
export function editImageFailCallback(taskId: string, layerId: string) {
  const { render } = useCanvasStore.getState();
  render?.Actions.setLoaded(layerId);
  deleteTask(taskId);
}

/**
   * 判断是否有mask
   *
   * @param {(ImageData | null)} imageData
   * @return {*}
   */
export function isHasMask(imageData: ImageData | null, masks?: FabricObject[]) {
  if (!masks?.length) return false;
  if (!imageData) return false;
  for (let i = 0; i < imageData.data.length; i += 4) {
    if (imageData.data[i + 3] > 0) {
      return true;
    }
  }
  return false;
}

/**
 * 当redo后，当前重新渲染到画布上的元素可能还在任务中，需要重新设置Loading
 * 临时方法，后续优化任务与历史记录逻辑，此方法可删除
 * @export
 * @param {string[]} ids
 */
export function redoCallbackSetTaskLoading(ids: string[]) {
  const { render } = useCanvasStore.getState();
  for (const id of ids) {
    const object = render?.Finder.findById(id);
    if ((object instanceof FabricObject) && object?._name_ === ElementName.IMAGE) {
      const inTask = hasTaskByLayerId([object._id_]);
      if (inTask) {
        render?.Actions.setLoading({
          id: object._id_,
          type: LoadingType.CIRCLE_DANCE,
          text: ' ',
          blur: true,
          maskOpacity: 0.2,
        });
      }
    }
  }
}
